import Vuex from 'vuex'
import Vue from 'vue'
import largeSidebar from './modules/largeSidebar'
import compactSidebar from './modules/compactSidebar'
import chat from './modules/chat'
import themeConfig from './modules/themeConfig'
import authData from './modules/authData'
import invoice from './modules/invoice'
import cart from './modules/cart'
import verticalSidebar from './modules/verticalSidebar'
import scrumboard from './modules/scrumboard'
import axios from "axios";
import { BASEURL } from "@/api/baseurl";

// Load Vuex
Vue.use(Vuex)

// Create store
export default new Vuex.Store({
  state: {
    sessionPollInterval: null,
  },

  mutations: {
    SET_POLL_INTERVAL(state, interval) {
      state.sessionPollInterval = interval;
    },
    CLEAR_POLL_INTERVAL(state) {
      clearInterval(state.sessionPollInterval);
      state.sessionPollInterval = null;
    },
  },

  actions: {
    startSessionPolling({ commit, dispatch }) {
      // Clear any existing interval first
      commit("CLEAR_POLL_INTERVAL");

      const interval = setInterval(() => {
        dispatch("checkSession");
      }, 30000); // every 30 seconds

      commit("SET_POLL_INTERVAL", interval);
    },

    stopSessionPolling({ commit }) {
      commit("CLEAR_POLL_INTERVAL");
    },

    async checkSession({ dispatch }) {
      const token =
        localStorage.getItem("session_token") ||
        sessionStorage.getItem("session_token");

      // No token means already logged out
      if (!token) {
        dispatch("stopSessionPolling");
        return;
      }

      try {
        const params = new URLSearchParams();
        params.append("validate_session", "done");
        params.append("token", token);

        const response = await axios.post(
          `${BASEURL}/user/index.php`,
          params
        );

        if (response.data.status !== "1") {
          dispatch("forceLogout");
        }
      } catch (e) {
        console.log("Session check error:", e);
      }
    },

    forceLogout({ dispatch }) {
      dispatch("stopSessionPolling");

      localStorage.removeItem("userInfo");
      localStorage.removeItem("session_token");
      sessionStorage.removeItem("session_token");

      // ✅ Use window.location instead of router.push to avoid NavigationDuplicated
      window.location.href = "/app/sessions/login?reason=session_terminated";
    },
  },
  modules: {
    largeSidebar,
    compactSidebar,
    chat,
    themeConfig,
    authData,
    invoice,
    cart,
    verticalSidebar,
    scrumboard,
  },
})
